import { LayoutDashboard, Building2, PlusCircle, Users, BarChart3, CreditCard } from "lucide-react";
import DashboardLayout from "@/components/layout/DashboardLayout";

const NAV_ITEMS = [
  { to: "/ali-admin-portal/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "admin-nav-dashboard" },
  { to: "/ali-admin-portal/clinics", label: "Clinics", icon: Building2, testId: "admin-nav-clinics" },
  { to: "/ali-admin-portal/clinics/new", label: "Create Clinic", icon: PlusCircle, testId: "admin-nav-create-clinic" },
  { to: "/ali-admin-portal/subscriptions", label: "Manage Subscription", icon: CreditCard, testId: "admin-nav-subscriptions" },
  { to: "/ali-admin-portal/analytics", label: "Analytics", icon: BarChart3, testId: "admin-nav-analytics" },
  { to: "/ali-admin-portal/leads", label: "Leads", icon: Users, testId: "admin-nav-leads" },
];

export default function AdminLayout({ children }) {
  return (
    <DashboardLayout navItems={NAV_ITEMS} roleLabel="Super Admin">
      {children}
    </DashboardLayout>
  );
}
